// @flow
import React from "react";
import Table from "containers/Table";

import type { CellProps } from "containers/Table/types";

const TableTshirt = (props) => {
  const columns = [
    {
      name: "personName",
      title: "Name",
      sortable: true,
      filterable: true,
      active: true,
    },
    {
      name: "tshirtSize",
      title: "Shirt Size",
      sortable: true,
      filterable: false,
      active: true,
    },
    {
      name: "institution",
      title: "Institution",
      sortable: true,
      filterable: true,
      active: true,
    },
    {
      name: "teamName",
      title: "Team",
      sortable: true,
      filterable: true,
      active: true,
    },
  ];
  const defaultColumnWidths = [
    { columnName: "personName", width: "300px" },
    { columnName: "tshirtSize", width: "200px" },
    { columnName: "institution", width: "200px" },
    { columnName: "teamName", width: "200px" },
  ];
  const template = (cell: CellProps) => {
    return undefined;
  };
  return (
    <Table
      title="Tshirt"
      url={props.tshirtURL}
      exportUrl={props.exportURL}
      columns={columns}
      defaultColumnWidths={defaultColumnWidths}
      template={template}
    />
  );
};

export default TableTshirt;
